
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire47f6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire47f6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3GH9i", function(module, exports) {

$parcel$export(module.exports, "API", function () { return $3a03b3a4dee42e9f$export$2c4e825dc9120f87; });

var $kaGFG = parcelRequire("kaGFG");
class $3a03b3a4dee42e9f$export$2c4e825dc9120f87 {
    static instance = new $3a03b3a4dee42e9f$export$2c4e825dc9120f87();
    async getAssessment(id, eventId) {
        var resolve;
        let idPath = id ? `/${id}` : '';
        idPath += eventId ? `?eventId=${eventId}` : '';
        const res = await fetch(`/api/assessment${idPath}`);
        if (res.status !== 200) throw new Error(`Failed to get an assessment - ${res.status}`);
        const body = await res.json();
        return (0, $kaGFG.ResearchEntry).fromAPI(body);
    }
}

});
parcelRegister("kaGFG", function(module, exports) {

$parcel$export(module.exports, "ResearchEntry", function () { return $64158b84e246ea33$export$f6309b6ede3d9cc4; });
class $64158b84e246ea33$export$f6309b6ede3d9cc4 {
    url;
    name;
    returnUrl;
    canEmbed;
    static fromAPI(entry) {
        return new $64158b84e246ea33$export$f6309b6ede3d9cc4(entry['url'], entry['name'], entry['returnUrl'], entry['canEmbed']);
    }
    constructor(url, name, returnUrl, canEmbed = false){
        this.url = url;
        this.name = name;
        this.returnUrl = returnUrl;
        this.canEmbed = canEmbed;
    }
}

});



var $3GH9i = parcelRequire("3GH9i");
const $0ecff0b7f8b695e0$export$64ed9f5b88f0e6f8 = (url)=>{
    const queryValueIndex = url.indexOf('=');
    return decodeURIComponent(url.slice(queryValueIndex + 1));
};
const $0ecff0b7f8b695e0$export$fab00cdb9c2c794f = (url)=>{
    return `${url.slice(0, url.lastIndexOf('/'))}/`;
};
const $0ecff0b7f8b695e0$export$a8351ed306b93de0 = (token)=>{
    const jwtDataPart = token.split('.')[1];
    const decoded = atob(jwtDataPart);
    return JSON.parse(decoded.toString()).candidateId;
};


const $ef2f0c7f474e4656$var$eventTypes = [
    'DestroyGame'
];
class $ef2f0c7f474e4656$export$60883f7f09b537d9 {
    url;
    componentName;
    component;
    constructor(url, componentName){
        this.url = url;
        this.componentName = componentName;
        this.component = document.createElement(this.componentName);
    }
    /**
   * Initializes the component by attaching the script, and then creating the element once the script has
   * loaded
   */ async init() {
        await this.initScript();
        this.initElement();
    }
    /**
   * Attaches the component to the DOM
   */ attachTo(element) {
        console.debug(`Attaching <${this.componentName}> to the DOM`);
        element.appendChild(this.component);
        this.component?.classList.add('assessment');
    }
    addListeners() {
        $ef2f0c7f474e4656$var$eventTypes.forEach((eventType)=>{
            this.component.addEventListener(eventType, (event)=>{
                if (eventType === 'DestroyGame') {
                    const returnUrl = event.detail.returnUrl;
                    window.location.assign(returnUrl);
                }
            });
        });
    }
    /**
   * Creates the script element, adds the source of the web component and appends it to the DOM
   */ initScript() {
        const script = document.createElement('script');
        const baseUrl = (0, $0ecff0b7f8b695e0$export$fab00cdb9c2c794f)(this.url);
        console.debug(`Creating script, with src ${baseUrl}component.js`);
        const promise = new Promise((resolve, reject)=>{
            script.onload = ()=>resolve(true);
            script.onerror = (e)=>reject(e);
        });
        document.head.appendChild(script);
        script.src = baseUrl + `component.js`;
        return promise;
    }
    /**
   * Sets the relevant attributes on the component
   */ initElement() {
        // Attaches the token to the component
        const token = (0, $0ecff0b7f8b695e0$export$64ed9f5b88f0e6f8)(this.url);
        // These should be consolidated but adding both for support for now. work required in either the assessments or games
        this.component.setAttribute('token', token);
        this.component.setAttribute('accesstoken', token);
    }
}


const $d41afcdce09d3fe4$var$contentTemplate = document.querySelector('#contentTemplate');
const $d41afcdce09d3fe4$var$noResearchTemplate = document.querySelector('#noResearchTemplate');
const $d41afcdce09d3fe4$var$errorTemplate = document.querySelector('#errorTemplate');
const $d41afcdce09d3fe4$export$26d55645375ca9a = document.querySelector('#loader');
const $d41afcdce09d3fe4$export$d1213e82613ff4df = document.querySelector('.content');
const $d41afcdce09d3fe4$export$8af11e0544f36d75 = $d41afcdce09d3fe4$var$contentTemplate.content.cloneNode(true);
const $d41afcdce09d3fe4$export$58be27a2f1b1222e = $d41afcdce09d3fe4$var$noResearchTemplate.content.cloneNode(true);
const $d41afcdce09d3fe4$export$4df7413a74b20b4e = $d41afcdce09d3fe4$var$errorTemplate.content.cloneNode(true);



class $01356ace2239899b$var$ResearchValidation {
    static instance = new $01356ace2239899b$var$ResearchValidation();
    component;
    /**
   * Get an assessment from the API, and either redirects or attaches
   * it to the DOM
   */ async init() {
        const urlParams = new URLSearchParams(window.location.search);
        const eventId = urlParams.get('eventId') ?? 'research-eventId';
        const assessment = await this.getAssessmentFromAPI(eventId);
        if (!assessment) return;
        if (assessment.name === 'survey') {
            const url = new URL(assessment.url);
            if (eventId) url.searchParams.append('eventId', eventId);
            window.location.assign(url);
        } else {
            const token = (0, $0ecff0b7f8b695e0$export$64ed9f5b88f0e6f8)(assessment.url);
            const cid = (0, $0ecff0b7f8b695e0$export$a8351ed306b93de0)(token);
            localStorage.setItem('research_cid', cid);
            localStorage.setItem('research_event_id', eventId);
            if (assessment.canEmbed) {
                this.component = new (0, $ef2f0c7f474e4656$export$60883f7f09b537d9)(assessment.url, assessment.name);
                await this.component.init();
            }
            (0, $d41afcdce09d3fe4$export$d1213e82613ff4df).appendChild((0, $d41afcdce09d3fe4$export$8af11e0544f36d75));
            (0, $d41afcdce09d3fe4$export$26d55645375ca9a).style.display = 'none';
            (0, $d41afcdce09d3fe4$export$d1213e82613ff4df).querySelector('#play')?.addEventListener('click', ()=>this.playAssessment(assessment));
        }
    }
    async getAssessmentFromAPI(eventId) {
        try {
            return await (0, $3GH9i.API).instance.getAssessment(undefined, eventId);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-ignored-exceptions
        } catch (e) {
            (0, $d41afcdce09d3fe4$export$d1213e82613ff4df).appendChild((0, $d41afcdce09d3fe4$export$58be27a2f1b1222e));
            (0, $d41afcdce09d3fe4$export$26d55645375ca9a).style.display = 'none';
        }
        return undefined;
    }
    playAssessment(assessment) {
        // If it's a web component, attach it to the DOM
        if (this.component) {
            (0, $d41afcdce09d3fe4$export$d1213e82613ff4df).querySelector('#play')?.setAttribute('disabled', 'true');
            this.component.attachTo((0, $d41afcdce09d3fe4$export$d1213e82613ff4df));
            this.component.addListeners();
            return;
        }
        // Otherwise redirect to assessment
        window.location.assign(assessment.url);
    }
    showError(message) {
        (0, $d41afcdce09d3fe4$export$d1213e82613ff4df).appendChild((0, $d41afcdce09d3fe4$export$4df7413a74b20b4e));
        (0, $d41afcdce09d3fe4$export$26d55645375ca9a).style.display = 'none';
        (0, $d41afcdce09d3fe4$export$d1213e82613ff4df).querySelector('.error-message').innerText = message;
    }
}
$01356ace2239899b$var$ResearchValidation.instance.init();


//# sourceMappingURL=site.4ffb3aee.js.map
